import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Contact } from '../models/contact';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private readonly apiUrl =
    'https://applicationform.aldawal.com/api/Contact';

  constructor(private http: HttpClient) {}

  sendContactMessage(contact: Contact): Observable<any> {
    return this.http.post<any>(this.apiUrl, contact);
  }
}